export const DEFAULT_GRID_ELEMENT_HEIGHT = 308;
